import { Box, Input, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import * as React from 'react';
import { useState } from 'react';

export const TagsSearchInput = ({
    setSearchQuery,
}: {
    setSearchQuery: (searchQuery: string) => void;
}) => {
    const [searchInput, setSearchInput] = useState('');

    // Debounce search query to prevent focus loss
    React.useEffect(() => {
        const timer = setTimeout(() => {
            setSearchQuery(searchInput);
        }, 300);

        return () => clearTimeout(timer);
    }, [searchInput, setSearchQuery]);

    return (
        <Box sx={{ p: 1, borderBottom: 1, borderColor: 'divider' }}>
            <Input
                placeholder="Search tags..."
                value={searchInput}
                onChange={e => setSearchInput(e.target.value)}
                onKeyDown={e => e.stopPropagation()}
                onKeyUp={e => e.stopPropagation()}
                fullWidth
                startAdornment={
                    <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                    </InputAdornment>
                }
                sx={{ mb: 1 }}
            />
        </Box>
    );
};
